import { useState } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';

export const CheckboxInput = (props: WidgetProps) => {
  const { value, onChange, readonly } = props;
  const [checked, setChecked] = useState<boolean>(!!value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    onChange(e.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={handleChange}
          disabled={readonly}
          size="small"
        />
      }
      label={props.uiSchema?.['ui:title'] || props.label || ''}
      sx={{ '& .MuiFormControlLabel-label': { fontSize: '.875rem' } }}
    />
  );
};

export default CheckboxInput;
